import React from 'react';
import { useForm } from '@inertiajs/react';

interface Props {
  flash?: {
    alert?: string;
  };
  token: string;
}

export default function PasswordsEdit({ flash, token }: Props) {
  const { data, setData, put, processing, errors } = useForm({
    password: '',
    password_confirmation: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    put(`/passwords/${token}`);
  };

  return (
    <div className="auth-container">
      <h1>Update your password</h1>

      {flash?.alert && (
        <div style={{ color: 'red' }}>{flash.alert}</div>
      )}

      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            required
            autoComplete="new-password"
            placeholder="Enter new password"
            maxLength={72}
          />
          {errors.password && (
            <div style={{ color: 'red' }}>{errors.password}</div>
          )}
        </div>

        <div>
          <input
            type="password"
            value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            required
            autoComplete="new-password"
            placeholder="Repeat new password"
            maxLength={72}
          />
          {errors.password_confirmation && (
            <div style={{ color: 'red' }}>{errors.password_confirmation}</div>
          )}
        </div>

        <button type="submit" disabled={processing}>
          {processing ? 'Saving...' : 'Save'}
        </button>
      </form>
    </div>
  );
}